import Vue from 'vue'
import { loading,fullScreenContainer,scrollBoard,charts,decoration8,decoration5,digitalFlop,scrollRankingBoard} from '@jiaminghi/data-view'
Vue.use(loading);
Vue.use(fullScreenContainer);
Vue.use(scrollBoard);
Vue.use(charts)
Vue.use(decoration8)
Vue.use(decoration5)
Vue.use(digitalFlop)
Vue.use(scrollRankingBoard)